interface LevelAwareSystemRoles {
  VIEWER: string;
  DATA_EDITOR: string;
}

interface LevelAwareLicenseLevels {
  ONE: string;
  ONE_PLUS_EDIT: string;
  TWO: string;
}

interface LevelAwareMixin {
  SYSTEM_ROLES: LevelAwareSystemRoles;
  LICENSE_LEVELS: LevelAwareLicenseLevels;
}

/**
 * Mixin which supplies constants, properties, and helper methods making a widget level aware.
 */
class LevelAware {
  // ┌───────────┐
  // │ Constants │
  // └───────────┘
  SYSTEM_ROLES: LevelAwareSystemRoles = {
    VIEWER: "iAAAAAAAAAAAAAAA",
    DATA_EDITOR: "iBBBBBBBBBBBBBBB"
  };
  LICENSE_LEVELS: LevelAwareLicenseLevels = {
    ONE: "1",
    ONE_PLUS_EDIT: "11",
    TWO: "2"
  };
}

export default LevelAware;
